export const STORE_NAME_CONSTANTS = {
    USER_PERSISTANT: "user-store",
    USER_PREFERENCE: "user-preference",
    CHAT_DATA: "chatData",
    USER_DATA: "userData",
    SITE_DATA: "siteData",
    AI_CREATION_DATA: "aiCreationData",
}